import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import Leaflet from 'leaflet';
import { Marker, Popup } from 'react-leaflet';

class NewsMaker extends Component {
  static propTypes = {
    position: PropTypes.object.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string,
  };

  static defaultProps = {
    type: 'info',
    title: '',
    subtitle: '',
    content: '',
  };


  render() {
    const {
      type, title, subtitle, position, content,
    } = this.props;
    if (!position || !position.lat || !position.lng) {
      return null;
    }
    // console.log(position)
    let icon;
    switch (type) {
      case 'info':
        icon = Leaflet.icon({
          iconUrl: '/images/marker-info.svg',
          iconSize: [38, 95],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        });
        break;
      case 'alert':
        icon = Leaflet.icon({
          iconUrl: '/images/marker-alert.svg',
          iconSize: [38, 95],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        });
        break;
      default:
        icon = Leaflet.icon({
          iconUrl: '/images/marker-info.svg',
          iconSize: [38, 95],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        });
        break;
    }

    return (
      <Marker position={position} icon={icon}>
        <Popup>
          <span>
            <Header>
              {title}
              {subtitle && (<Header.Subheader>{subtitle}</Header.Subheader>)}
            </Header>
            {!content || (<p className="whiteSpacePre smalldescriptiontext">{content}</p>)}

          </span>
        </Popup>
      </Marker>
    );
  }
}

export default NewsMaker;



// WEBPACK FOOTER //
// ./src/components/Maps/NewsMarker.js